import React, { Dispatch, SetStateAction, forwardRef } from 'react';
import { NavLink } from 'react-router-dom';

import './WpTab.scss';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;

export interface Props {
  children: React.ReactNode;
  activeTab?: string;
  onTabClick?: Dispatcher<string>;
  trackOnClick?: () => void;
  tabId?: string;
  to?: string;
  exact?: boolean;
  qaTest?: string;
  badge?: React.ReactNode;
}

const WpTab = forwardRef(function (
  { children, activeTab, tabId = '', onTabClick, trackOnClick, to, exact = false, qaTest, badge }: Props,
  innerRef: any
) {
  const isActive = activeTab === tabId;

  const classNamePrefix = 'WpTab';

  return (
    <>
      {to ? (
        <div className={classNamePrefix}>
          <NavLink
            to={to}
            exact={exact}
            ref={innerRef}
            className={`${classNamePrefix}__tab`}
            onClick={() => {
              onTabClick(tabId);
              trackOnClick && trackOnClick();
            }}
            activeClassName={`${classNamePrefix}__tab--active`}
            data-test={qaTest}
          >
            {children}
          </NavLink>
          {badge && <span className={`${classNamePrefix}__badge`}>{badge}</span>}
        </div>
      ) : (
        <div className={classNamePrefix}>
          <div
            ref={innerRef}
            className={`${classNamePrefix}__tab ${isActive && `${classNamePrefix}__tab--active`}`}
            onClick={() => {
              onTabClick(tabId);
              trackOnClick && trackOnClick();
            }}
            data-test={qaTest}
          >
            {children}
          </div>
          {badge && <span className={`${classNamePrefix}__badge`}>{badge}</span>}
        </div>
      )}
    </>
  );
});

export default WpTab;
